import { render, staticRenderFns } from "./PriceSliderFilter.vue?vue&type=template&id=4dcb78fc&"
import script from "./PriceSliderFilter.vue?vue&type=script&lang=js&"
export * from "./PriceSliderFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports